import {
  totalAtv,
  totalConv,
  totalRec,
  totalTaxes,
  totalUpt,
} from './financeInvoiceTotals';

/** API GET /finance/invoices/:id → { company, invoices[], can_approve, ... } */
export const adaptFinanceInvoiceSingle = (allData) => {
  const rows = allData?.invoices || [];
  if (!rows.length) {
    return { allData, id: null };
  }

  const { total_taxable, total_taxable_vat } = totalTaxes({ rows });
  const receipts_sum = totalRec({ rows, key: 'receipts' });
  const pieces_sum = totalRec({ rows, key: 'pieces' });
  const visitors_sum = totalRec({ rows, key: 'visitors' });

  const statuses = [...new Set(rows.map((r) => r.status).filter(Boolean))];
  const status = statuses.length === 1 ? statuses[0] : statuses[0];

  return {
    id: rows[0].id,
    allData,
    company: allData.company,
    company_name: allData.company?.name,
    can_approve: allData.can_approve,
    can_update: allData.can_update ?? allData.can_approve,
    invoice_date: rows[0].invoice_date,
    date: rows[0].invoice_date,
    week_closed: rows.every((r) => r.week_closed),
    status,
    taxable_sum: total_taxable,
    taxable_vat_sum: total_taxable_vat,
    receipts_sum: String(receipts_sum),
    pieces_sum: String(pieces_sum),
    visitors_sum: String(visitors_sum),
    atv_sum: totalAtv({ rows }),
    upt_sum: totalUpt({ rows }),
    conversion_rate_sum: totalConv({ rows }),
  };
};
